import { Button } from 'antd';
import styled from 'styled-components';

export const SectionTitle = styled.h3`
    font-size: 12px;
    margin: 0 0 10px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: ${({ theme }) => theme.colors.lightFont};
    font-weight: 700;
`;

export const Section = styled.div`
    margin-bottom: 22px;
`;

export const FieldsGrid = styled.div`
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr;
`;

export const FieldLabel = styled.label`
    display: block;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.lightFont};
    margin-bottom: 5px;
`;

export const SuggestedBox = styled.div`
    min-height: 56px;
    box-sizing: border-box;
    padding: 6px 12px;
    line-height: 1.3;
    border: 1px solid ${({ theme }) => theme.colors.infoSurfaceBorder};
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.infoSurfaceBg};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
`;

export const SuggestedValue = styled.strong`
    display: block;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.accentColor};
`;

export const UseSuggestedButton = styled(Button)`
    && {
        height: 32px;
        padding: 0 14px;
        border: none;
        border-radius: 8px;
        background: ${({ theme }) => theme.colors.infoSurfaceButtonBg};
        color: ${({ theme }) => theme.colors.accentColor};
        font-weight: 700;

        &:hover:not(:disabled) {
            background: ${({ theme }) => theme.colors.colorPrimaryBgHover};
            color: ${({ theme }) => theme.colors.accentColor};
        }

        &:disabled {
            background: ${({ theme }) => theme.colors.colorBgContainerDisabled};
            color: ${({ theme }) => theme.colors.colorTextDisabled};
        }
    }
`;

export const ImpactBox = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.infoSurfaceBorder};
    background: ${({ theme }) => theme.colors.infoSurfaceBg};
    border-radius: 12px;
    padding: 12px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 10px;
`;

export const ImpactItem = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.lightFont};

    &:not(:first-child) {
        border-left: 1px solid ${({ theme }) => theme.colors.infoSurfaceBorder};
        padding-left: 10px;
    }
`;

export const ImpactValue = styled.strong<{ color?: string }>`
    display: block;
    color: ${({ color, theme }) => color ?? theme.colors.antdText};
    font-size: 15px;
    margin-top: 3px;
`;

export const DeleteSection = styled.div`
    border-top: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    padding-top: 18px;
    margin-top: 22px;
`;

export const DeleteConfirmBox = styled.div`
    background: ${({ theme }) => theme.colors.colorErrorBg};
    border: 1px solid ${({ theme }) => theme.colors.colorErrorBorder};
    border-radius: 10px;
    padding: 14px;
`;

export const DeleteConfirmText = styled.p`
    margin: 0 0 10px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.colorErrorText};
`;

export const DeleteButton = styled(Button)`
    && {
        display: flex;
        margin: 0 auto;
        align-items: center;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.colorError};

        &:hover:not(:disabled) {
            color: ${({ theme }) => theme.colors.colorError};
            background: ${({ theme }) => theme.colors.colorErrorBg};
        }
    }
`;

export const CloseButton = styled.button`
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.colorBgContainer};
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const FooterActions = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
`;

export const CancelButton = styled(Button)`
    && {
        width: 38%;
        height: 44px;
        border-radius: 10px;
        font-weight: 700;
    }
`;

export const SaveButton = styled(Button)`
    && {
        flex: 1;
        height: 44px;
        border-radius: 10px;
        font-weight: 700;
    }
`;
